export * from '@primeuix/themes/lara/ripple';
export { default } from '@primeuix/themes/lara/ripple';
